import React from 'react';
import Workflows from '../components/Workflows';

const WorkflowsPage = () => {
  return (
    <div>
      <Workflows />
    </div>
  );
};

export default WorkflowsPage;





